var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tc mationDialog"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('incompleteResume')))]),_c('div',{},[_vm._v(_vm._s(_vm.$t('attentionYou')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }